import { required, email } from '../../utils/validators';

export const constraints = {
  email: [required(), email()],
};

export interface FormData {
  email: string;
}
